import {
  Box,
  Button,
  Chip,
  FormControl,
  Grid,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import Header from "../../../components/header/Header";
import { DataGrid } from "@mui/x-data-grid";
import "./style.css";
import deleteRow from "../../../assets/images/delete.png";
import ReusableDeleteDialogue from "../../../components/reusableDialog/ReusableDeleteDialogue";
import ReusableDialog from "../../../components/reusableDialog/ReusableDialog";
import { Link, useNavigate, useParams } from "react-router-dom";
import searchIcon from "../../../assets/images/SearchIcon.png";
import { Card } from "../../../components/card/Card";
import searchIconFilter from "../../../assets/images/searchIconFilter.png";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  fetchBatcherOverviewData,
  deleteBatch,
} from "../../../pages/afterAuth/batch/batchOverview/redux/actionCreator";
// import GreenDot from " ../../../../ /assets/images/GreenDot.png";
import GreenDot from "../../../assets/images/GreenDot.png";
import RedDot from "../../../assets/images/RedDot.png";
import { toast } from "react-toastify";
import RouteContext from "../../../utils/context/RouteContext";
import { useContext } from "react";
import { roles } from "../../sidenav/constant";
import EnrolSubAdminDialog from "../../../pages/afterAuth/userManagement/subAdmin/EnrolSubAdminDialog";
import { getSubAdminUserService } from "../../../utils/services/userManagement/subAdmin/subAdminServices";
import { deleteBatchService } from "../../../utils/services/batchesOverview/batchOverviewService";
import AddBatchDialog from "./AddBatchDialog";

const BatchesOverview = () => {
  const access = JSON.parse(localStorage.getItem("level"));
  const levelPermission = access?.Batch?.write;
  const { role } = useContext(RouteContext);
  const { data } = useSelector((state) => state?.batchOveriew);
  const [subAdminLimit, setSubAdminLimit] = useState(10);

  const { courseId, courseName } = useParams();
  // setCourseID(id);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  // const [courseName, setCourseName] = useState();
  const [batchId, setSearchTerm] = useState("");
  const [deleteBatchId, setDeleteBatchId] = useState("");

  // --------> Modal for Enrol Sub Admin  <--------
  const [subAdmindata, setSubAdminData] = useState([]);
  const [enrollSubAdminOpen, setEnrollSubAdminOpen] = useState(false);
  const [subAdminMeetingId, SetSubAdminMeetingId] = useState();
  const [addBatchModal, setAddBatchModal] = useState(false);

  console.log(data, "batchasdasdasdasdasdasdas");

  const fetchSubAdminList = async () => {
    try {
      const params = {
        pageNo: 1,
        pageLength: subAdminLimit,
      };
      const result = await getSubAdminUserService(params);
      setSubAdminData(result?.data?.payload?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubAdminDialogOpen = (id) => {
    fetchSubAdminList();
    setEnrollSubAdminOpen(true);
    SetSubAdminMeetingId(id);
  };

  // ------------------------------------------------------

  const handleDialogOpen = () => {
    setIsOpen(true);
  };

  const handleDialougOpen = (params) => {
    setDeleteBatchId(params.row.id);
    setIsOpenDelete(!isOpenDelete);
  };

  const handleDialogClose = () => {
    setIsOpenDelete(!isOpenDelete);
    setDeleteBatchId("");
  };

  const handleDeleteBatch = async () => {
    const { error, message } = await deleteBatchService(deleteBatchId);
    if (!error) {
      dispatch(
        fetchBatcherOverviewData({ courseId: courseId, batchId: batchId })
      );
      toast.success(message);
      handleDialogClose();
    }
  };

  useEffect(() => {
    dispatch(
      fetchBatcherOverviewData({ courseId: courseId, batchId: batchId })
    );
  }, [batchId, courseId, dispatch]);

  const searchFunction = (event) => {
    setSearchTerm(event.target.value);
  };

  const loadMoreItems = () => {
    setSubAdminLimit((prev) => prev + 10);
  };

  useEffect(() => {
    fetchSubAdminList();
  }, [subAdminLimit]);

  const columns = [
    {
      field: "batchId",
      headerName: "Batch ID",
      width: 200,
      disableColumnMenu: true,
      headerClassName: "header-style",
      renderCell: (params) => {
        const { minSize, maxSize, batchStatus, batchType } = params.row;
        // const threshold = 0.8;
        // const maxsize=25;
        // const minsize=22;

        // const isbelowThreshold = minSize / maxSize < threshold;

        return (
          <Typography sx={{ display: "flex", alignItems: "center" }}>
            <img
              src={batchStatus === "closed" ? RedDot : GreenDot}
              alt="green"
              style={{
                objectFit: "contain",
                paddingRight: "1rem",
              }}
            />
            {batchType === "Self" ? (
              <span
                style={{ textDecoration: "underline", cursor: "pointer" }}
                // onClick={() => handleDialogOpen(cellValues)}
                // onClick={handleTrainerForm}
                onClick={() => {
                  navigate(
                    "/batch/batchesoverview/add-self-batch?formType=edit-self-batch",
                    {
                      state: {
                        course: data,
                        courseId: courseId,
                        courseName: courseName,
                        batchId: params.row.id,
                        batchName: params.row.batchId,
                        batchStatus: params.row.batchStatus,
                      },
                    }
                  );
                }}
              >
                {params.value}
              </span>
            ) : (
              <span
                style={{ textDecoration: "underline", cursor: "pointer" }}
                // onClick={() => handleDialogOpen(cellValues)}
                // onClick={handleTrainerForm}
                onClick={() => {
                  navigate(
                    "/batch/batchesoverview/add-batch?formType=edit-batch",
                    {
                      state: {
                        course: data,
                        courseId: courseId,
                        courseName: courseName,
                        batchId: params.row.id,
                        batchName: params.row.batchId,
                        batchStatus: params.row.batchStatus,
                      },
                    }
                  );
                }}
              >
                {params.value}
              </span>
            )}
          </Typography>
        );
      },
    },
    {
      field: "startenddate",
      headerName: "Start / End",
      // width: 200,
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      headerClassName: "header-style",
      valueGetter: (params) => {
        const { startDate, endDate, batchType } = params?.row; // Assuming your API response has separate startdate and enddate fields

        const formatDate = (dateString) => {
          const date = new Date(dateString);
          const options = { day: "numeric", month: "long" };
          return date.toLocaleDateString("en-GB", options);
        };

        const formattedStartDate = formatDate(startDate);
        const formattedEndDate = formatDate(endDate);
        if (batchType === "Self") return;
        return `${formattedStartDate}-${formattedEndDate}`;
      },
    },
    {
      field: "trainerName",
      headerName: "Trainer",
      // width: 100,
      flex: 1,
      disableColumnMenu: true,
      headerClassName: "header-style",
    },
    {
      field: "batchType",
      headerName: "Batch Type",
      // width: 100,
      flex: 1,
      disableColumnMenu: true,
      headerClassName: "header-style",
      renderCell: (params) => {
        const isWeb = params?.row?.isWeb;
        return (
          <>
            <p>
              {params?.row?.batchType}
              {params?.row?.batchType === "Self"
                ? isWeb === true
                  ? "(New)"
                  : "(Old)"
                : ""}
            </p>
          </>
        );
      },
    },
    {
      field: "duration",
      headerName: "Duration",
      // width: 100,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      headerClassName: "header-style",
      // renderCell: (params) => (
      //   <a href={params.value} target="_blank" rel="noopener noreferrer">
      //     {params.value}
      //   </a>
      // ),
    },
    {
      field: "SeatStats",
      headerName: "Seat Stats",
      width: 250,
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
      headerClassName: "header-style",
      renderCell: (params) => {
        const { maxSize, minSize, filledSeats, batchType } = params.row;
        const threshold = 0.8;
        // const maxsize=25;
        // const minsize=22;

        const isbelowThreshold = minSize / maxSize < threshold;

        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {batchType === "Self" ? (
              <></>
            ) : (
              <span
                style={{
                  color: isbelowThreshold ? "#14A406" : "#BF5649",
                }}
              >{`${params?.row?.filledSeats}/${params.row.maxSize}`}</span>
            )}
            <Chip
              label={params.row.batchStatus}
              style={{
                backgroundColor:
                  params.row.batchStatus === "closed"
                    ? "#BF5649"
                    : params.row.batchStatus === "upcoming"
                    ? "#14A406"
                    : "yellow",
                // color: "#fff",
                color: params.row.batchStatus === "ongoing" ? "black" : "#fff",
                width: "6rem",
                marginLeft: ".5rem",
                height: "1.5rem",
                fontSize: ".6rem",
              }}
            />
          </Box>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      headerAlign: "center",
      // width: 170,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      align: "center",
      headerClassName: "header-style",
      renderCell: (params) => (
        <>
          {params?.row?.batchStatus === "closed" ? (
            <>
              <div style={{ padding: "1rem", cursor: "pointer" }}>
                <img
                  onClick={
                    role === "Admin" || (roles.SUB_ADMIN && levelPermission)
                      ? () => handleDialougOpen(params)
                      : () => {}
                  }
                  src={deleteRow}
                  alt="Action"
                />
              </div>{" "}
            </>
          ) : (
            <>
              <FormControl fullWidth>
                <Select
                  // sx={{}}
                  inputProps={{
                    IconComponent: () => null,
                    sx: { padding: "0 !important" },
                  }}
                  displayEmpty
                  sx={{
                    borderRadius: "2rem",
                    padding: "2rem",
                    "& > fieldset": { border: "none" },
                    padding: "1rem",
                    paddingLeft: "2.5rem",
                    borderRadius: "2rem",
                  }}
                  renderValue={() => (
                    <img
                      style={{
                        display: "flex",
                        marginRight: "auto",
                        marginLeft: "auto",
                        paddingRight: "1.3rem",
                      }}
                      src={deleteRow}
                      alt="Action"
                    />
                  )}
                >
                  {params?.row?.batchType === "Live" && (
                    <MenuItem
                      sx={{
                        backgroundColor: "transparent !important",
                        padding: ".8rem .5rem .4rem .5rem",
                      }}
                      onClick={() => {
                        console.log("params -> ", params?.row);
                        handleSubAdminDialogOpen(params?.row?.meetingId);
                      }}
                    >
                      Enroll Sub Admins
                    </MenuItem>
                  )}
                  <MenuItem
                    onClick={
                      role === "Admin" || (roles.SUB_ADMIN && levelPermission)
                        ? () => handleDialougOpen(params)
                        : () => {}
                    }
                    sx={{
                      backgroundColor: "transparent !important",

                      padding: ".8rem .5rem .4rem .5rem",
                    }}
                  >
                    Remove Batch
                  </MenuItem>
                </Select>
              </FormControl>
            </>
          )}
        </>

        // --------------------------------------------------------------------------------------
        // <div style={{ padding: "1rem", cursor: "pointer" }}>
        //   <img
        //     onClick={
        //       role === "Admin" || (roles.SUB_ADMIN  && levelPermission)
        //         ? () => handleDialougOpen(params)
        //         : () => {}
        //     }
        //     src={deleteRow}
        //     alt="Action"
        //   />
        // </div>
      ),
    },
  ];

  const handleNavigate = () => {
    navigate("/batch");
  };

  const handleAddBatch = () => {
    setAddBatchModal(true);
  };

  const handleCloseDialog = () => {
    setAddBatchModal(false);
  };

  return (
    <>
      <Grid className="content-container">
        <Header />
        <div
          style={{
            width: "75vw",
            margin: "auto",
          }}
        >
          <Grid
            container
            className="information-container"
            style={{
              backgroundColor: "#F7F7F7",
            }}
          >
            <div
              className="FilterBar--Container"
              style={{
                width: "100%",
              }}
            >
              <p>
                {" "}
                <span style={{ cursor: "pointer" }} onClick={handleNavigate}>
                  Course /
                </span>{" "}
                {/* {courseId} */}
                {courseName}
              </p>
              <h1 className="information-container-header">Batches Overview</h1>

              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <div className="batch-card">
                    <h2>
                      <b>{data?.activeBatch}</b>
                    </h2>
                    <p>Total Ongoing Batches</p>
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div className="batch-card">
                    <h2>
                      <b>{data?.activeStudent}</b>
                    </h2>
                    <p>Total Active Students</p>
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div className="batch-card">
                    <h2>
                      <b>{data?.totalBatch}</b>
                    </h2>
                    <p>Total Batches</p>
                  </div>
                </Grid>
              </Grid>
            </div>
            <Grid sx={{ height: "53vh", width: "100%", marginTop: "1rem" }}>
              <div
                className="FilterBar--SearchContainers "
                style={{
                  width: "100%",
                }}
              >
                <div
                  style={{
                    marginTop: "0rem",
                    padding: "1rem",
                    backgroundColor: "white",
                    borderRadius: "0.5rem",
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <div style={{ display: "flex", flex: "1" }}>
                    <TextField
                      // value={searchValue}
                      onChange={searchFunction}
                      sx={{
                        backgroundColor: "#F2F2F2",
                        height: "2.5rem",
                        flex: "1",
                        padding: "0.2rem 2rem 0.5rem 1.5rem",
                        border: "none",
                        borderRadius: ".5rem 0 0 .5rem",
                        paddingBottom: "10px",
                      }}
                      placeholder="Search Batch"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <img src={searchIcon} alt="" />
                          </InputAdornment>
                        ),
                        disableUnderline: true,
                      }}
                      variant="standard"
                    />
                    <Button
                      sx={{
                        height: "2.5rem",
                        width: "6.5625rem",
                        backgroundColor: "#ffffff",
                        color: "#1A5AFA",
                        borderColor: "#e6e6e6",
                        textTransform: "none",
                      }}
                      variant="outlined"
                    >
                      Search
                    </Button>
                  </div>
                  {/* <div style={{ marginLeft: "1rem ", cursor: "pointer" }}>
                    <img src={searchIconFilter} alt="Advance Search" />
                  </div> */}

                  <div>
                    {(role === "Admin" ||
                      (role === roles.SUB_ADMIN && levelPermission)) && (
                      <Button
                        sx={{
                          height: "2.5rem",
                          // width: "10rem",
                          backgroundColor: "#ffffff",
                          color: "#1A5AFA",
                          fontWeight: "bolder",
                          marginLeft: "1rem",
                          textTransform: "none",
                          border: "1.5px solid #1A5AFA",
                        }}
                        variant="outlined"
                        // onClick={() =>
                        //   navigate("/batch/batchesoverview/add-batch", {
                        //     state: {
                        //       course: data,
                        //       courseId: courseId,
                        //       courseName: courseName,
                        //     },
                        //   })
                        // }
                        onClick={handleAddBatch}
                      >
                        + Add Batch
                      </Button>
                    )}
                  </div>
                </div>

                <ReusableDialog
                  title="Title of modal"
                  search="search here"
                  isOpen={isOpen}
                  children={"Please Pass the Dialog Content"}
                  handleDialogClose={handleDialogClose}
                >
                  "Dialogie content here"
                </ReusableDialog>
              </div>
              <DataGrid
                sx={{ border: "0px", background: "white" }}
                rows={data?.batchList || []}
                columns={columns}
              />
            </Grid>
          </Grid>
        </div>
      </Grid>
      <ReusableDeleteDialogue
        setIsOpenDelete={setIsOpenDelete}
        heading="Remove Batch"
        description=" Are you sure you want to remove this batch?"
        isOpenDelete={isOpenDelete}
        yesClicked={handleDeleteBatch}
        handleClose={handleDialogClose}
        // handleDeleteConfirmation={handleDeleteConfirmation}
      />
      <AddBatchDialog
        addBatchModal={addBatchModal}
        setAddBatchModal={setAddBatchModal}
        handleCloseDialog={handleCloseDialog}
        courseId={courseId}
        courseName={courseName}
      />
      {subAdmindata && (
        <EnrolSubAdminDialog
          setIsOpen={setEnrollSubAdminOpen}
          isOpen={enrollSubAdminOpen}
          enrollSubAdminLists={subAdmindata}
          loadMoreItems={loadMoreItems}
          subAdminMeetingId={subAdminMeetingId}
        />
      )}
    </>
  );
};
export default BatchesOverview;
